module.exports = __webpack_public_path__ + "georgia.svg?5745f2903a70efc766d6eb2ef25a8ea6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/georgia.svg
// module id = 172
// module chunks = 10